import { isEmpty, pick, omit } from 'lodash';
import ErrorsBag from 'services/validation/ErrorsBag';
import validator from './validator';

export default function Form(data, validations)
{
    this.data = data || {};
    this.validations = validations;
    this.errorsBag = new ErrorsBag();

    /**
     *
     * @param key
     */
    this.deleteError = function (key) // eslint-disable-line func-names
    {
        this.errorsBag.deleteError(key);
    };

    /**
     *
     * @returns {ErrorsBag}
     */
    this.getErrors = function () // eslint-disable-line func-names
    {
        return this.errorsBag;
    };

    /**
     *
     * @returns {bool}
     */
    this.isValid = function () // eslint-disable-line func-names
    {
        return isEmpty(this.errorsBag.errors);
    };

    this.validate = function (fields) // eslint-disable-line func-names
    {
        const currentErrors = fields ? omit(this.errorsBag.errors, fields) : {};
        const _validations = fields ? pick(this.validations, fields) : this.validations;
        const result = validator(this.data, _validations);

        this.errorsBag.errors = {
            ...currentErrors,
            ...result,
        };
    };
}
